import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import {
  Account,
  getImagePath,
} from '@jaimo-solutions-gmbh/platform-services-module';

@Component({
  selector: 'app-account-tile',
  templateUrl: './account-tile.component.html',
  styleUrls: ['./account-tile.component.scss'],
})
export class AccountTileComponent implements OnInit {
  @Input() account: Account;
  @Input() size: 'medium' | 'small' = 'medium';

  constructor(private navCtrl: NavController) {}

  ngOnInit(): void {}

  getImage = (filename?: string) => getImagePath() + filename;

  goToStage = () => {
    this.navCtrl.navigateForward(this.account.handle);
  };
}
